import { Box, SpeedDial, SpeedDialIcon, Typography } from '@mui/material';
import React, { useState } from 'react'
import UserGroup from '../../../../../components/administrative/users/userGroup/userGroup';
import GroupsTable from '../../../../../components/administrative/users/groupsTable/groupsTable';

const UserGroupsPage = () => {
  const [values, setValues] = useState({});
  const [open, setOpen] = useState(false);
  const [editing, setEditing] = useState(false);
  const [changed, setChanged ] = useState(false);

  const handleChanged = () => {
    setChanged(!changed);
  }

  const handleNewGroup = () => {
    setEditing(false);
    setValues({});
    setOpen(true);
  }

  return (
    <Box style={{padding: 5}}>
      <Box>
        <UserGroup 
          open={open}
          setOpen={setOpen} 
          values={values}
          setValues={setValues}
          editing={editing}
          setEditing={setEditing}
          changed={changed}
          handleChanged={handleChanged}          
        />
      </Box>
      <div>
        <SpeedDial
              ariaLabel="Novo grupo"
              sx={{ position: 'fixed', bottom: 70, right: 16, }}
              icon={<SpeedDialIcon  />}
              onClick={() => handleNewGroup()}
              >
        </SpeedDial>
      </div>
      <GroupsTable
        open={open}
        setOpen={setOpen} 
        values={values}
        setValues={setValues}
        editing={editing}
        setEditing={setEditing}
        changed={changed}
        handleChanged={handleChanged}
        />
    </Box>
  )
}

export default UserGroupsPage;